var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainPreloader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes mainPreloader{0%{opacity:1}to{opacity:0}}")), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.82 24.279c5.553 5.555 14.558 5.555 20.112 0 5.554-5.554 5.554-14.56 0-20.113-5.554-5.555-14.559-5.555-20.112 0-5.555 5.554-5.555 14.559 0 20.113z",
    fill: "#fff",
    style: {
      animation: "mainPreloader 1.5s linear infinite -1.3125s"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.178 33.412c0 7.854 6.364 14.222 14.222 14.222 7.853 0 14.222-6.368 14.222-14.222 0-7.856-6.369-14.223-14.222-14.223-7.858 0-14.222 6.367-14.222 14.223z",
    fill: "#fff",
    style: {
      animation: "mainPreloader 1.5s linear infinite -1.125s"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.67 69.82c-5.554 5.554-5.554 14.56 0 20.113 5.555 5.554 14.56 5.554 20.113 0 5.555-5.554 5.555-14.559 0-20.113-5.553-5.555-14.558-5.555-20.113 0z",
    fill: "#fff",
    style: {
      animation: "mainPreloader 1.5s linear infinite -.9375s"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.54 112.178c-7.855 0-14.223 6.364-14.223 14.222 0 7.853 6.368 14.222 14.223 14.222 7.854 0 14.222-6.369 14.222-14.222 0-7.858-6.368-14.222-14.222-14.222z",
    fill: "#fff",
    style: {
      animation: "mainPreloader 1.5s linear infinite -.75s"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.131 135.671c-5.554-5.554-14.559-5.554-20.113 0-5.553 5.555-5.553 14.56 0 20.112 5.554 5.555 14.56 5.555 20.113 0 5.555-5.552 5.555-14.557 0-20.112z",
    fill: "#fff",
    style: {
      animation: "mainPreloader 1.5s linear infinite -.5625s"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.773 126.54c0-7.854-6.367-14.222-14.223-14.222-7.853 0-14.222 6.368-14.222 14.222 0 7.854 6.37 14.222 14.222 14.222 7.856 0 14.223-6.368 14.223-14.222z",
    fill: "#fff",
    style: {
      animation: "mainPreloader 1.5s linear infinite -.375s"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.278 90.132c5.555-5.554 5.555-14.559 0-20.112-5.553-5.554-14.558-5.554-20.112 0-5.555 5.553-5.555 14.558 0 20.112 5.554 5.555 14.558 5.555 20.112 0z",
    fill: "#fff",
    style: {
      animation: "mainPreloader 1.5s linear infinite -.1875s"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.41 47.775c7.855 0 14.223-6.369 14.223-14.222 0-7.855-6.368-14.222-14.222-14.222-7.856 0-14.223 6.367-14.223 14.222 0 7.853 6.367 14.222 14.223 14.222z",
    fill: "#fff",
    style: {
      animation: "mainPreloader 1.5s linear infinite 0s"
    }
  }));
}
export default SvgMainPreloader;